(ns frontend.ux-overhaul.listing.investor.event
  (:require [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.view.entity :as entity]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::create-investor
 (fn [_ [_ {:keys [legal-entity-type]}]]
   ;; Without a legal entity type the creator uses a company. The listing menu
   ;; passes the type that the user picked. `:skip-success-msg?` is also needed.
   ;; Without it the creator shows nothing after a successful create. The Create
   ;; menu in the navigation bar uses the same options.
   (entity/open-creator! :entity.type/investor
                         (cond-> {:ident             [:investor-creator]
                                  :skip-success-msg? true}
                           legal-entity-type
                           (assoc :legal-entity-type legal-entity-type)))
   {}))

(rf/reg-event-fx
 ::open-bulk-edit
 (fn [_ [_ {:keys [listing-id]}]]
   (rf/dispatch [::bulk-actions/open-bulk-edit {:listing-id listing-id}])
   {}))

(rf/reg-event-fx
 ::bulk-delete-selected
 (fn [{:keys [db]} [_ {:keys [listing-id]}]]
   (bulk-actions/bulk-delete-selected!
    {:db        db
     :listing-id listing-id
     :operation :investor/mass-action
     :body-fn   (fn [ids]
                  {:action       :delete-investors
                   :investor-ids ids})})
   {}))

(rf/reg-event-fx
 ::export-grid
 (fn [_ [_ {:keys [listing-id]}]]
   (bulk-actions/export-grid! {:listing-id  listing-id
                               :entity-type :entity.type/investor})
   {}))

(rf/reg-event-fx
 ::export-grid-with-persons
 (fn [_ [_ {:keys [listing-id]}]]
   (bulk-actions/export-grid! {:listing-id                   listing-id
                               :entity-type                  :entity.type/investor
                               :include-associated-persons? true})
   {}))
